import DOMPurify from 'dompurify';

/**
 * [AB#748] `ReleaseNote.descricao` é renderizada via `dangerouslySetInnerHTML`
 * em dois lugares — o admin (AdminReleaseNotes) e o modal "O que há de novo"
 * (ReleaseNotesModal, visto por todo usuário). O backend já sanitiza na
 * gravação (mesma allowlist, `sanitizar-html.util.ts`) — isto é defesa em
 * profundidade: cobre notas gravadas ANTES da correção (achado real em
 * PROD, v0.1.66: HTML completo com `<style>` vazou pra página inteira).
 */
const TAGS_PERMITIDAS = ['h1', 'h2', 'h3', 'p', 'ul', 'ol', 'li', 'strong', 'em', 'a'];
const ATRIBUTOS_PERMITIDOS = ['href'];

export function sanitizarDescricaoReleaseNote(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: TAGS_PERMITIDAS,
    ALLOWED_ATTR: ATRIBUTOS_PERMITIDOS,
  });
}
